/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteMenuItemModel as DigiworkMaitreDPosDtoMenuDeleteMenuItemModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Menu/delete-menu-item-model';

export interface DeleteMenuItem$Params {
      body?: DigiworkMaitreDPosDtoMenuDeleteMenuItemModel
}

export function deleteMenuItem(http: HttpClient, rootUrl: string, params?: DeleteMenuItem$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteMenuItem.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteMenuItem.PATH = '/api/gmn/Menu/deletemenuitem';
